import { generateReadActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";
import ACTION_NAMES from "actions/ACTION_NAMES";

const getLeadSources = generateReadActionCreator(routes.API_LEAD_SOURCES, ACTION_NAMES.LEAD_SOURCES);

export default {
    getLeadSources
}
